import { combineReducers } from "redux";
import authReducer from '../reducers/authReducer';
import apiCalls from '../reducers/questionReducer';

const reducers = combineReducers({
    fireauth : authReducer,
    allApiCalls :apiCalls
})

export default reducers